import { useEffect } from "react";
import { create } from "zustand";

/**
 * How many app overlays (MediaViewer, the composer / uploads / cast modals, a post dialog) are open.
 * Any of them covers the stream dock, so the dock's wall card holds a YouTube / SoundCloud item while
 * one is open (Android: the dock window loses focus). A count, so stacked overlays release only when
 * the last one closes.
 */
interface AppOverlayState {
  count: number;
  open(): void;
  close(): void;
}

export const useAppOverlayStore = create<AppOverlayState>((set) => ({
  count: 0,
  open: () => set((s) => ({ count: s.count + 1 })),
  close: () => set((s) => ({ count: Math.max(0, s.count - 1) })),
}));

/** Registers the calling component as an open overlay while it is mounted (and `active`). */
export function useAppOverlay(active = true): void {
  useEffect(() => {
    if (!active) return;
    useAppOverlayStore.getState().open();
    return () => useAppOverlayStore.getState().close();
  }, [active]);
}

/** Tests: no overlay open. */
export const resetAppOverlayStore = (): void => useAppOverlayStore.setState({ count: 0 });
